var obj = {
  index: function () {
    this.preloading();          // 预加载
    this.floatCode();           // 游戏下载浮窗
    this.indexBind();           // 首页按钮
    this.newYearTime();         // 新年设置
  },
  // 图片资源预加载
  preloading: function () {
    //图片预加载
    var queue = new createjs.LoadQueue();
    queue.on("progress", function (e) {
      //加载中的进度
      if (e.progress * 100 >= 10) {
        $(".loding_time div span").width(parseInt(e.progress * 100) + '%')
      }
      var numbers = e.progress * 100;
      
    }, this);
    queue.on("complete", function (e) {
      //加载完成执行操作
      $('.loding_time').remove();
      $('.preloading').addClass('preloading-ani').fadeOut(1000);
      $('.index').addClass('index-show');
      this.indexSwiper();// 首页大轮播
      setTimeout(function () {
        $('.bg').addClass('bg-ani');
      }, 500);
    }, this);
    queue.loadManifest([
      //加载图片，不包括后台的
      '//static.qcplay.com/snail/azygx/images/pc/m_dt_sz.png',
      '//static.qcplay.com/snail/azygx/images/pc/m_dt_t.png',
      '//static.qcplay.com/snail/azygx/images/pc/m_jdt.png',
      '//static.qcplay.com/snail/azygx/images/pc/title_img.png',
      '//static.qcplay.com/snail/azygx/images/pc/logo_img.png',
      '//static.qcplay.com/snail/azygx/images/pc/snail.png',
      '//static.qcplay.com/snail/azygx/images/pc/snail_04.png',
      '//static.qcplay.com/snail/azygx/images/pc/title_img.png',
      '//static.qcplay.com/snail/azygx/images/pc/camera.png',
      '//static.qcplay.com/snail/azygx/images/pc/cloud_01.png',
      '//static.qcplay.com/snail/azygx/images/pc/cloud_02.png',
      '//static.qcplay.com/snail/azygx/images/pc/cloud_03.png',
      '//static.qcplay.com/snail/azygx/images/pc/cloud_04.png',
      '//static.qcplay.com/snail/azygx/images/pc/film.png',
      '//static.qcplay.com/snail/azygx/images/pc/shine.png',
    ]);
  },

  // 首页轮播
  indexSwiper: function () {
    var mySwiper = new Swiper('.swiper-container', {
      pagination: '.swiper-pagination',
      direction: 'vertical',
      slidesPerView: 'auto',
      paginationClickable: true,
      spaceBetween: 0,
      mousewheelControl: true,
      resistanceRatio: 0,
      onInit: function (swiper) {
        swiperAnimate(swiper);
      },
      onSlideChangeEnd: function (swiper) {
        swiperAnimate(swiper);
      },
    });
    
    function tabSwiperTwo(swiperClass, swiperPagin) {
      var swiper3 = new Swiper(swiperClass, {
        pagination: swiperPagin,
        nextButton: '.swiper-button-next',
        prevButton: '.swiper-button-prev',
        paginationClickable: true,
        spaceBetween: 50,
        speed: 300,
        loop: true,
        onInit: function (swiper) {
          swiperAnimate(swiper);
        },
        onSlideChangeEnd: function (swiper) {
          swiperAnimate(swiper);
        },
        onTouchEnd: function (swiper) {
          swiperAnimate(swiper);
        },
      });
    }
    
    var swiperX1 = tabSwiperTwo('.swiper-container2', '.swiper-pagination');
    var swiperX2 = tabSwiperTwo('.swiper-container3', '.swiper-pagination-02');
    var dataNum = null;
    $('.swiper-container3 .slide-04 .act-box').on('click', function (event) {
      dataNum = $(this).attr('data');
      $('.act-dec-popup').fadeIn().addClass('act-dec-0' + dataNum + '');
    });
    //适龄弹窗
    $('.year_box').on('click', function (event) {
      $('.year_pop').fadeIn();
    });
    $('.close-btn').click(function (event) {
      $('.act-dec-popup').fadeOut().removeClass('act-dec-0' + dataNum + '');
      $('.year_pop').fadeOut();
    });
  },
  // 游戏下载浮窗
  floatCode: function () {
    
    // 下载链接
    $('.btn-box').on('click', 'a', function () {
      var className = $(this).attr('class');
      // console.log(className)
      var game_id = 39;
      $.ajax({
        type: "get",
        url: 'https://api.qingcigame.com/get_url?game_id=' + game_id + '',
        dataType: 'json',
        success: function (json) {
          if (className.indexOf('app-btn') !== -1) {
            // ios
            if (json.data.ios_down_url == '') {
              layer.msg('ios下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', {time: 3000});
            } else {
              location.href = json.data.ios_down_url
            }
          } else {
            // 安卓
            if (json.data.android_download_url == '') {
              layer.msg('安卓下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', {time: 3000});
            } else {
              location.href = json.data.android_down_url
            }
          }
        }
      })
    });
    
    // 点击左侧二维码浮窗
    $('.float-code .changes-btn').on('click', 'a', function (event) {
      !$('.float-code').hasClass('select') ? $('.float-code').addClass('select') : $('.float-code').removeClass('select');
    });
    $('.float-code').addClass('select');
    
  },
  
  indexBind: function () {
    
    $('#share-2').share({sites: ['qzone', 'qq', 'weibo', 'wechat']});
    
    $.ajax({
      url: "https://api.qingcigame.com/snail/pay/number?id=29",
      type: "POST",
      xhrFields: {
        withCredentials: true
      },
      success: function (json) {
        if (json.code == 200) {
          $('.number-data').html(json.data.number);
        } else {
          layer.msg("服务器请求失败", {time: 2000});
        }
      }, error: function () {
        layer.msg("服务器请求失败", {time: 2000});
        layer.close(index);
      }
    })
  },
  newYearTime: function () {
    var date = {
      isDuringDate: function (beginDateStr, endDateStr) {
        var curDate = new Date(),
            beginDate = new Date(beginDateStr),
            endDate = new Date(endDateStr);
        if (curDate >= beginDate && curDate <= endDate) {
          $('.act-box-03').addClass('new-act-box-03');
          return true;
        }
      }
    };
    date.isDuringDate('2021/02/12', '2022/02/12');
  }
}